// src/common.types.ts
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["info"] = "info";
  LogLevel2["warn"] = "warn";
  LogLevel2["error"] = "error";
  LogLevel2["debug"] = "debug";
  LogLevel2["trace"] = "trace";
  LogLevel2["fatal"] = "fatal";
  return LogLevel2;
})(LogLevel || {});
export {
  LogLevel
};
//# sourceMappingURL=index.js.map